// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dMjbi","title":"styles_title__9amUT","subTitle":"styles_subTitle__wFt4c"};